import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from "react";
import { validateOrg, validateSsn } from "@ssfbank/norwegian-id-validators";
import Organisationsnummer from "organisationsnummer";
import Personnummer from "personnummer";
import { validateTin, formatTinInput } from "../../../../../../../util/tin-validation";
type Locale = "en" | "no" | "sv" | "et" | "dk";
interface UseSsnValidationParams {
  locale: Locale;
  taxDeductionChecked: boolean;
}
interface UseSsnValidationResult {
  validateSsn: (value: string, isAnonymous: boolean) => boolean;
  handleSsnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  cprSuspicious: boolean;
}
export function useSsnValidation(t0) {
  const $ = _c(10);
  const {
    locale,
    taxDeductionChecked
  } = t0;
  const [cprSuspicious, setCprSuspicious] = useState(false);
  let t1;
  if ($[0] !== locale || $[1] !== taxDeductionChecked) {
    t1 = (value, isAnonymous) => {
      if (isAnonymous || !taxDeductionChecked) {
        return true;
      }
      const trimmed = value.toString().trim();
      if (locale === "no") {
        return validateSsnNo(trimmed);
      }
      if (locale === "sv") {
        return validateSsnSe(trimmed);
      }
      if (locale === "dk") {
        const validationResult = validateTin(trimmed, {
          allowCvr: true
        });
        if (validationResult.type === "CPR") {
          if (validationResult.isSuspicious) {
            setCprSuspicious(true);
            return true;
          } else {
            if (validationResult.isValid && !validationResult.isSuspicious) {
              setCprSuspicious(false);
            }
          }
        } else {
          setCprSuspicious(false);
        }
        return validationResult.isValid;
      }
      return true;
    };
    $[0] = locale;
    $[1] = taxDeductionChecked;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const validateSsnValue = t1;
  let t2;
  if ($[3] !== locale || $[4] !== taxDeductionChecked) {
    t2 = e => {
      const {
        value: value_0
      } = e.target;
      if (locale === "dk" && taxDeductionChecked) {
        const formattedValue = formatTinInput(value_0, {
          allowCvr: true
        });
        e.target.value = formattedValue;
        const digits = formattedValue.replace(/\D/g, "");
        if (digits.length === 10 || digits.length === 8) {
          const validationResult_0 = validateTin(formattedValue, {
            allowCvr: true
          });
          setCprSuspicious(validationResult_0.type === "CPR" && validationResult_0.isSuspicious);
        } else {
          setCprSuspicious(false);
        }
      }
    };
    $[3] = locale;
    $[4] = taxDeductionChecked;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleSsnChange = t2;
  let t3;
  if ($[6] !== cprSuspicious || $[7] !== handleSsnChange || $[8] !== validateSsnValue) {
    t3 = {
      validateSsn: validateSsnValue,
      handleSsnChange,
      cprSuspicious
    };
    $[6] = cprSuspicious;
    $[7] = handleSsnChange;
    $[8] = validateSsnValue;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function validateSsnNo(ssn: string): boolean {
  return ssn.length === 9 && validateOrg(ssn) || ssn.length === 11 && validateSsn(ssn);
}
function validateSsnSe(ssn: string): boolean {
  return Personnummer.valid(ssn) || Organisationsnummer.valid(ssn);
}